var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"validate-on-blur":"","aria-label":"name","type":"text","name":_vm.property,"placeholder":_vm.placeholder,"autofocus":_vm.autofocus,"rules":_vm.computedRules,"required":"","outlined":"","dense":"","label":_vm.label,"autocomplete":_vm.autocomplete}})
}
var staticRenderFns = []

export { render, staticRenderFns }